/**
 * Делает кликабельный блок настоящей кнопкой, не меняя того, как он выглядит.
 *
 * `onClick` на `Box` или `Flex` работает только мышью и пальцем: до такого элемента нельзя дойти
 * табом, и экранная читалка не назовёт его действием. Половина списка людей, занять место в
 * сессии, открыть панель действий над сообщением — всё это было недостижимо с клавиатуры.
 *
 * `textAlign: 'left'` здесь обязателен и не косметика: браузер центрирует текст внутри `button`,
 * и без него строка с именем и подписью съезжает в середину. Это видно сразу, глазом.
 *
 * Обводка только в `_focusVisible`: она появляется, когда до элемента дошли клавишей, и не
 * появляется от клика мышью. Для человека с мышью не меняется ничего.
 *
 * Ширину, скругление и подсветку при наведении набор не трогает: они принадлежат месту, а не
 * роли. Вызывающий добавляет их сам, как и `aria-label`, если по содержимому не понять, что
 * произойдёт при нажатии.
 *
 * Отклик на нажатие входит в роль, а не в место: настоящая кнопка проседает на 3% (рецепт
 * кнопки, `pressFeedback`), и блок, который притворяется кнопкой, обязан вести себя так же.
 * Иначе половина списка людей отвечает на палец, а половина нет, и разница видна именно на
 * телефоне, где подсветки под курсором не существует.
 */
export const asButton = {
  as: 'button',
  type: 'button',
  textAlign: 'left',
  transition: 'transform var(--chakra-durations-moderate) var(--chakra-easings-ease-out)',
  _active: { transform: 'scale(0.97)' },
  _disabled: { _active: { transform: 'none' } },
  _motionReduce: {
    transition: 'none',
    transform: 'none',
    _active: { transform: 'none' },
  },
  _focusVisible: {
    outline: '2px solid',
    outlineColor: 'purple.focusRing',
    outlineOffset: '2px',
  },
} as const;
